module.exports = __webpack_public_path__ + "media/favicon/apple-touch-icon-41e3c3db.png";